import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ yPadding?: number }>()(
  (theme, { yPadding = 2 }) => ({
    button: {
      borderRadius: '10px',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      border: `1px solid ${theme.palette.primary.main}`,
      textTransform: 'capitalize',
      transition: 'all 0.15s linear',
      boxShadow: 'none !important',
      padding: theme.spacing(yPadding, 1),
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        border: `1px solid ${theme.palette.primary.light}`,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '1rem',
      },
    },
    circularProgress: {
      color: theme.palette.primary.contrastText,
    },
  }),
);
